import React from "react";
import Sidebar from "../components/sidebar";
import Header from "./../components/Header";
import AddOrderStatusMain from "../components/order status/AddOrderStatus";
// import AddUnitMain from "../components/units/AddUnit";

const AddOrderStatus = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <AddOrderStatusMain />
      </main>
    </>
  );
};

export default AddOrderStatus;
